import type { ReactNode } from 'react';

export const symbol_voicemail: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M251-320q-75 0-127.5-52.5T71-500q0-75 52.5-127.5T251-680q75 0 127.5 52.5T431-500q0 33.66-13.5 64.83T381-380h199q-23-25-36.5-55.5T530-500q0-75 52.5-127.5T710-680q75 0 128 52.5T891-500q0 75-52.79 127.5T710-320H251Zm0-60q50.4 0 85.2-35 34.8-35 34.8-85t-34.8-85q-34.8-35-85.2-35-50.4 0-85.2 35-34.8 35-34.8 85t34.8 85q34.8 35 85.2 35Zm459 0q50.4 0 85.2-35 34.8-35 34.8-85t-34.8-85q-34.8-35-85.2-35-50.4 0-85.2 35-34.8 35-34.8 85t34.8 85q34.8 35 85.2 35Z"
		/>
	</svg>
);
